/* ============================================================================
   GENERATED FILE — DO NOT EDIT BY HAND.
   Source:    Pricing/sheet-export-2026-08-10.xlsx (Components + BuildPricing sheets)
   Generator: scripts/sync-pricing.py (T-083 — replaces legacy sync-components.js)
   ============================================================================ */
window.HIISI_COMPONENTS_DATA = [
  {
    "id": "brakes-sram-maven",
    "category": "brakes",
    "brand": "SRAM",
    "label": "Maven Ultimate (F+R)",
    "leadDays": 60,
    "msrp": 605,
    "weightGrams": 1140
  },
  {
    "id": "fork-zeb-160",
    "category": "fork",
    "brand": "RockShox",
    "label": "ZEB Ultimate",
    "leadDays": 60,
    "msrp": 1049,
    "weightGrams": 2300,
    "travel": 160,
    "compatibleTravels": [
      152
    ]
  },
  {
    "id": "fork-zeb-180",
    "category": "fork",
    "brand": "RockShox",
    "label": "ZEB Ultimate",
    "leadDays": 60,
    "msrp": 1049,
    "weightGrams": 2340,
    "travel": 180,
    "compatibleTravels": [
      173,
      180
    ]
  },
  {
    "id": "fork-boxxer-200",
    "category": "fork",
    "brand": "RockShox",
    "label": "Boxxer",
    "leadDays": 60,
    "msrp": 1915,
    "weightGrams": 2840,
    "travel": 200,
    "compatibleTravels": [
      200
    ]
  },
  {
    "id": "fork-intend-160",
    "category": "fork",
    "brand": "Intend",
    "label": "Flash",
    "leadDays": 30,
    "msrp": 1890,
    "weightGrams": 2370,
    "travel": 160,
    "compatibleTravels": [
      152
    ]
  },
  {
    "id": "fork-intend-180",
    "category": "fork",
    "brand": "Intend",
    "label": "Flash",
    "leadDays": 30,
    "msrp": 1890,
    "weightGrams": 2410,
    "travel": 180,
    "compatibleTravels": [
      173,
      180
    ]
  },
  {
    "id": "fork-intend-190",
    "category": "fork",
    "brand": "Intend",
    "label": "Flash",
    "leadDays": 30,
    "msrp": 1890,
    "weightGrams": 2430,
    "travel": 190,
    "compatibleTravels": [
      180,
      200
    ]
  },
  {
    "id": "shock-rs-vivid",
    "category": "shock",
    "brand": "RockShox",
    "label": "Vivid Ultimate",
    "leadDays": 60,
    "msrp": 714,
    "weightGrams": 570
  },
  {
    "id": "shock-ext-arma4",
    "category": "shock",
    "brand": "EXT",
    "label": "Arma V4",
    "leadDays": 30,
    "msrp": 898,
    "weightGrams": 570
  },
  {
    "id": "shock-intend-hover",
    "category": "shock",
    "brand": "Intend",
    "label": "Hover",
    "leadDays": 30,
    "msrp": 966,
    "weightGrams": 425
  },
  {
    "id": "tires-schwalbe",
    "category": "tires",
    "brand": "Schwalbe",
    "label": "Magic Mary / Tacky Chan Gravity Pro",
    "leadDays": 30,
    "msrp": 140,
    "weightGrams": 2625
  },
  {
    "id": "tires-schwalbe-trail",
    "category": "tires",
    "brand": "Schwalbe",
    "label": "Magic Mary / Tacky Chan Trail PRO",
    "leadDays": 30,
    "msrp": 120,
    "weightGrams": 2140,
    "compatibleTravels": [
      152,
      173
    ]
  },
  {
    "id": "wheels-dt-fr1500",
    "category": "wheels",
    "brand": "DT Swiss",
    "label": "FR 1500 Classic",
    "leadDays": 180,
    "msrp": 755,
    "weightGrams": 2250
  },
  {
    "id": "wheels-dt-exc1200",
    "category": "wheels",
    "brand": "DT Swiss",
    "label": "EXC 1200 Classic",
    "leadDays": 180,
    "msrp": 2100,
    "weightGrams": 1810
  },
  {
    "id": "wheels-newmen-beskar",
    "category": "wheels",
    "brand": "Newmen",
    "label": "Beskar 30 J-Bend Enduro",
    "leadDays": 60,
    "msrp": 571,
    "weightGrams": 2040,
    "compatibleTravels": [
      173,
      180,
      200
    ]
  },
  {
    "id": "wheels-newmen-phase",
    "category": "wheels",
    "brand": "Newmen",
    "label": "Phase 30 J-Bend Carbon Enduro",
    "leadDays": 60,
    "msrp": 1084,
    "weightGrams": 1800
  },
  {
    "id": "wheels-newmen-beskar-trail",
    "category": "wheels",
    "brand": "Newmen",
    "label": "Beskar 30 Trail",
    "leadDays": 60,
    "msrp": 571,
    "weightGrams": 1750,
    "compatibleTravels": [
      152,
      173
    ]
  },
  {
    "id": "wheels-newmen-phase-vonoa",
    "category": "wheels",
    "brand": "Newmen",
    "label": "Phase 30 VONOA Trail",
    "leadDays": 60,
    "msrp": 1336,
    "weightGrams": 1200,
    "compatibleTravels": [
      152
    ]
  },
  {
    "id": "bar-bikeyoke-alloy",
    "category": "handlebar",
    "brand": "BikeYoke",
    "label": "Barmate AlS 800 × 65 mm",
    "leadDays": 60,
    "msrp": 75,
    "weightGrams": 300
  },
  {
    "id": "bar-bikeyoke-carbon",
    "category": "handlebar",
    "brand": "BikeYoke",
    "label": "Barmate Carbon 800 × 65 mm",
    "leadDays": 60,
    "msrp": 226,
    "weightGrams": 260
  },
  {
    "id": "stem-bikeyoke-barkeeper",
    "category": "stem",
    "brand": "BikeYoke",
    "label": "Barkeeper 45 mm",
    "leadDays": 60,
    "msrp": 75,
    "weightGrams": 96
  },
  {
    "id": "headset-enduro",
    "category": "headset",
    "brand": "Enduro",
    "label": "ZS44/ZS56",
    "leadDays": 60,
    "msrp": 94,
    "weightGrams": 120
  },
  {
    "id": "saddle-bikeyoke-alloy",
    "category": "saddle",
    "brand": "BikeYoke",
    "label": "SAGMA 3D Lite 142",
    "leadDays": 60,
    "msrp": 127,
    "weightGrams": 260
  },
  {
    "id": "saddle-bikeyoke-carbon",
    "category": "saddle",
    "brand": "BikeYoke",
    "label": "SAGMA 3D Carbon 142",
    "leadDays": 60,
    "msrp": 209,
    "weightGrams": 200
  },
  {
    "id": "post-rs-axs-100",
    "category": "seatpost",
    "brand": "RockShox",
    "label": "Reverb AXS 100 mm",
    "leadDays": 60,
    "msrp": 580,
    "weightGrams": 600,
    "dropperTravel": 100
  },
  {
    "id": "post-rs-axs-125",
    "category": "seatpost",
    "brand": "RockShox",
    "label": "Reverb AXS 125 mm",
    "leadDays": 60,
    "msrp": 580,
    "weightGrams": 650,
    "dropperTravel": 125
  },
  {
    "id": "post-rs-axs-150",
    "category": "seatpost",
    "brand": "RockShox",
    "label": "Reverb AXS 150 mm",
    "leadDays": 60,
    "msrp": 580,
    "weightGrams": 700,
    "dropperTravel": 150
  },
  {
    "id": "post-rs-axs-175",
    "category": "seatpost",
    "brand": "RockShox",
    "label": "Reverb AXS 175 mm",
    "leadDays": 60,
    "msrp": 580,
    "weightGrams": 730,
    "dropperTravel": 175
  },
  {
    "id": "post-rs-axs-200",
    "category": "seatpost",
    "brand": "RockShox",
    "label": "Reverb AXS 200 mm",
    "leadDays": 60,
    "msrp": 580,
    "weightGrams": 780,
    "dropperTravel": 200
  },
  {
    "id": "post-rs-axs-225",
    "category": "seatpost",
    "brand": "RockShox",
    "label": "Reverb AXS 225 mm",
    "leadDays": 60,
    "msrp": 580,
    "weightGrams": 830,
    "dropperTravel": 225
  },
  {
    "id": "post-rs-axs-250",
    "category": "seatpost",
    "brand": "RockShox",
    "label": "Reverb AXS 250 mm",
    "leadDays": 60,
    "msrp": 580,
    "weightGrams": 880,
    "dropperTravel": 250
  },
  {
    "id": "crank-e13-alloy",
    "category": "cranks",
    "brand": "E*Thirteen",
    "label": "Helix Race Alloy e-MTB",
    "leadDays": 60,
    "msrp": 193,
    "weightGrams": 560
  },
  {
    "id": "crank-e13-carbon",
    "category": "cranks",
    "brand": "E*Thirteen",
    "label": "Helix Race Carbon e-MTB",
    "leadDays": 60,
    "msrp": 327,
    "weightGrams": 480
  },
  {
    "id": "chain-gx",
    "category": "chain",
    "brand": "SRAM",
    "label": "CN GX T-TYPE 126 link",
    "leadDays": 60,
    "msrp": 32,
    "weightGrams": 284
  },
  {
    "id": "chain-x0",
    "category": "chain",
    "brand": "SRAM",
    "label": "CN T-TYPE X0 A1",
    "leadDays": 60,
    "msrp": 92,
    "weightGrams": 285
  },
  {
    "id": "cassette-gx",
    "category": "cassette",
    "brand": "SRAM",
    "label": "GX Eagle Transmission XS-1275",
    "leadDays": 60,
    "msrp": 165,
    "weightGrams": 447
  },
  {
    "id": "cassette-x0",
    "category": "cassette",
    "brand": "SRAM",
    "label": "X0 Eagle Transmission XS-1295",
    "leadDays": 60,
    "msrp": 273,
    "weightGrams": 382
  },
  {
    "id": "cassette-xx",
    "category": "cassette",
    "brand": "SRAM",
    "label": "XX Eagle Transmission XS-1297",
    "leadDays": 60,
    "msrp": 338,
    "weightGrams": 382
  },
  {
    "id": "derailleur-gx",
    "category": "derailleur",
    "brand": "SRAM",
    "label": "RD GX Eagle AXS T-TYPE",
    "leadDays": 60,
    "msrp": 268,
    "weightGrams": 490
  },
  {
    "id": "derailleur-x0",
    "category": "derailleur",
    "brand": "SRAM",
    "label": "RD X0 Eagle AXS T-TYPE",
    "leadDays": 60,
    "msrp": 361,
    "weightGrams": 472
  },
  {
    "id": "derailleur-xx",
    "category": "derailleur",
    "brand": "SRAM",
    "label": "RD XX Eagle AXS T-TYPE",
    "leadDays": 60,
    "msrp": 428,
    "weightGrams": 463
  },
  {
    "id": "shifter-axs",
    "category": "shifter",
    "brand": "SRAM",
    "label": "EC AXS Rocker Right",
    "leadDays": 60,
    "msrp": 130,
    "weightGrams": 70
  },
  {
    "id": "grips-ams-cero",
    "category": "grips",
    "brand": "All Mountain Style",
    "label": "AMS Cero grips — Black",
    "leadDays": 14,
    "msrp": 0,
    "weightGrams": 100
  }
];

/* Customer-facing base prices, ex-VAT EUR. BuildPricing rows
   base_msrp_full_<travel> and base_msrp_frameset. MSRP is public; the
   cost rows sitting next to it in the same sheet are not and never
   reach this bundle. */
window.HIISI_PRICING_BASES = {
  "full": {
    "152": 11537,
    "173": 11552,
    "180": 11552,
    "200": 14875
  },
  "frameset": 7964
};

/* Customer-facing upcharges, ex-VAT EUR. BuildPricing rows
   mullet_upcharge, color_*_upcharge, chainguide_*_upcharge,
   film_protection_upcharge and range_extender_upcharge. */
window.HIISI_PRICING_UPCHARGES = {
  "mullet": 300,
  "color": {
    "Clear": 0,
    "Bronze": 980,
    "Gold": 980
  },
  "chainguideOnly": 120,
  "chainguideCombo": 250,
  "film": 490,
  "rangeExtender": 586,
  "deposit": 0
};
